import { CustomerState } from 'src/types/redux';
import {
  FETCH_CUSTOMER_FAILURE,
  FETCH_CUSTOMER_REQUEST,
  FETCH_CUSTOMER_SUCCESS,
  CustomerActionType,
  SET_START_END_DATE,
} from '../types/customerType';
import { oneDayAgoDate, todayDate } from 'src/utils/dateOneMonthAgo';

const initialState: CustomerState = {
  error: '',
  loading: false,
  customerData: [],
  customerStartDate: oneDayAgoDate(),
  customerEndDate: todayDate(),
};

export const customerReducer = (
  state = initialState,
  action: CustomerActionType
): CustomerState => {
  switch (action?.type) {
    case FETCH_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        customerData: action?.payload,
      };
    case FETCH_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    case SET_START_END_DATE:
      return {
        ...state,
        customerStartDate: action.payload?.startDate,
        customerEndDate: action.payload?.endDate,
      };
    default:
      return state;
  }
};
